import { render } from "./Manager.vue?vue&type=template&id=3bdebe4c&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"

import "./Manager.vue?vue&type=style&index=0&id=3bdebe4c&lang=css"
import "./Manager.vue?vue&type=style&index=1&id=3bdebe4c&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdebe4c"]])

export default __exports__